package music.jammers.client.shared.component.track.presentation.ui

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import limasoul.client.shared.generated.resources.Res
import limasoul.client.shared.generated.resources.ic_bass_circle
import limasoul.client.shared.generated.resources.ic_drums_circle
import limasoul.client.shared.generated.resources.ic_guitar_circle
import limasoul.client.shared.generated.resources.ic_keys_circle
import limasoul.client.shared.generated.resources.ic_mic_circle
import music.jammers.client.shared.component.Instrument
import music.jammers.client.shared.component.iconTintDark
import music.jammers.client.shared.component.iconTintLight
import music.jammers.shared.event.domain.model.EventMember
import music.jammers.shared.event.track.domain.model.BackgroundType
import music.jammers.shared.instrument.domain.model.InstrumentType
import org.jetbrains.compose.resources.painterResource

private const val DEFAULT_ALPHA = 1.0f
private const val OPTION_ALPHA = 0.3f

@Composable
fun TrackMember(
    eventMember: EventMember,
    backgroundType: BackgroundType,
    onClicked: (EventMember) -> Unit,
) {
    val instrument = getInstrumentByType(eventMember.instrumentType.instrument)
    val icon = instrument.icon
    val tintColor = getIconColor(backgroundType, eventMember.status)

    Icon(
        painter = painterResource(icon),
        tint = tintColor,
        contentDescription = "Instrument",
        modifier = Modifier.size(30.dp).clickable {
            onClicked(eventMember)
        }
    )
}

@Composable
internal fun getIconColor(backgroundType: BackgroundType, status: EventMember.Status): Color {
    val color = when (backgroundType) {
        BackgroundType.LIGHT -> iconTintDark
        BackgroundType.DARK  -> iconTintLight
    }

    val alpha = when (status) {
        EventMember.Status.BOOKED_OPTIONAL -> OPTION_ALPHA
        else                               -> DEFAULT_ALPHA
    }

    return color.copy(alpha = alpha)
}

private fun getInstrumentByType(type: InstrumentType): Instrument =
    when (type) {
        InstrumentType.VOCAL  -> Instrument(Res.drawable.ic_mic_circle, type)
        InstrumentType.GUITAR -> Instrument(Res.drawable.ic_guitar_circle, type)
        InstrumentType.BASS   -> Instrument(Res.drawable.ic_bass_circle, type)
        InstrumentType.PIANO  -> Instrument(Res.drawable.ic_keys_circle, type)
        InstrumentType.DRUMS  -> Instrument(Res.drawable.ic_drums_circle, type)
    }